import {createAction, props} from "@ngrx/store";
import {HangarQueue} from "../../models/HangarQueue";

export const UPDATE = '[HangarQueue] Update';
export const REFRESH = '[HangarQueue] Refresh';
export const update = createAction(UPDATE, props<{ hangarQueue: HangarQueue[] }>());
export const refresh = createAction(REFRESH);
